module.exports = __webpack_public_path__ + "img/20190829151013490.55fc27ac.jpg";